import { Chip } from '@/components/Chip';
import { Icon } from '@/components/Icon';
import { Menu } from '@/components/Menu';
import type { RozsahState } from './rozsah';

/**
 * Toolband filter for a combined list (skupina-vlastnictvi-plan §6.5): the active firma or every firma of the group
 * the user can read. Rendered only when the group offers a second firma.
 */
export function RozsahChip({ skupina }: { skupina: RozsahState }) {
  if (!skupina.canSpan) return null;
  return (
    <Menu>
      <Menu.Trigger asChild>
        <Chip icon={<Icon name="filter" size={12} />} active={skupina.rozsah === 'skupina'}>
          {skupina.rozsah === 'skupina' ? 'Všechny firmy skupiny' : 'Aktuální firma'}
        </Chip>
      </Menu.Trigger>
      <Menu.Content>
        <Menu.Label>Firmy</Menu.Label>
        <Menu.CheckItem
          checked={skupina.rozsah === 'aktivni'}
          onCheckedChange={(checked) => {
            if (checked) skupina.setRozsah('aktivni');
          }}
        >
          Aktuální firma
        </Menu.CheckItem>
        <Menu.CheckItem
          checked={skupina.rozsah === 'skupina'}
          onCheckedChange={(checked) => {
            if (checked) skupina.setRozsah('skupina');
          }}
        >
          Všechny firmy skupiny ({skupina.firmy.map((f) => f.nazev).join(', ')})
        </Menu.CheckItem>
      </Menu.Content>
    </Menu>
  );
}
